import React, { Component } from "react";

export default class Collapsible extends Component {
  componentDidUpdate() {}

  constructor(props) {
    super(props);
    this.detailRef = React.createRef();
  }

  scrollToMyRef = () =>
    this.detailRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

  render() {
    return (
      <div ref={this.detailRef}>
        <div
          onClick={(e) => {
            this.props.toggle(this.props.index);
            this.scrollToMyRef();
          }}
          className={
            this.props.headerClassName +
            (this.props.show ? " " + this.props.headerColor : "")
          }
        >
          {this.props.title}
        </div>
        {this.props.show ? (
          <span className={this.props.contentClassName}>
            {this.props.children}
          </span>
        ) : null}
      </div>
    );
  }
}
